import { render } from "./VirtualNumbersTableRow.vue?vue&type=template&id=6b81bd40"
import script from "./VirtualNumbersTableRow.vue?vue&type=script&lang=js"
export * from "./VirtualNumbersTableRow.vue?vue&type=script&lang=js"

import "./VirtualNumbersTableRow.vue?vue&type=style&index=0&id=6b81bd40&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__